import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useDistrictContext } from 'src/contexts/district.context';
import { IDistrict } from 'src/models/district.model';
import Lang from 'src/libraries/language';
import { getDistrictStatus } from 'src/selectors/district.selector';
import { actionTypes } from 'src/ducks/district.duck';
import styles from '../district-list/district-list.module.scss';

type IProp = {
  data: IDistrict;
};

const OperatorTailsDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useDistrictContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getDistrictStatus(state, actionTypes.DISTRICT_DELETE);

  const handleDelete = useCallback(async () => {
    if (data.key) {
      const response = await actions.itemDELETE(data.key);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();
        ToastSuccess(Lang.MSG_DISTRICT_DELETE_SUCCESS);
      } else {
        ToastError(response.error.message);
      }
    }
  }, [data, actions]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={styles.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_DISTRICT}
      content={
        <div className={styles.content}>{Lang.MSG_DISTRICT_CONFIRM_DELETE}</div>
      }
      actions={
        <div className={styles.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorTailsDelete;
